import { graphql, useStaticQuery } from "gatsby"

type ContentfulInline = {
  inlines: {
    nodes: {
      id: string
      internal: string
      contentful_id: string
      blockTitle?: string
      imageLink?: string
      sliderIntro?: any
      sliderItems?: any[]
      buttonUrl?: string
      buttonText?: string
      buttonColor?: string
      node_locale?: string
      internalPageReference: {
        slug?: string
      }
      formId: string
      portalId: string
      region: string
    }[]
  }
}
export const useContentfulInlines = (inlineID: string) => {
  const { inlines }: ContentfulInline = useStaticQuery(graphql`
    query inlinesQuery($locale: String) {
      inlines: allContentfulEntry(filter: { node_locale: { eq: $locale } }) {
        nodes {
          contentful_id
          id
          node_locale
          ... on ContentfulContentBlockHubSpotForm {
            formId
            portalId
            region
            meetingForm
            internal {
              type
            }
          }
          ... on ContentfulEdc22ContentBlockSlider {
            internal {
              type
            }
            sliderIntro {
              raw
            }
            sliderItems {
              doubleImage {
                file {
                  url
                }
              }
              image {
                file {
                  url
                }
              }
              text {
                raw
              }
            }
          }
          ... on ContentfulEdc22ContentBlockImageAndTextLink {
            internal {
              type
            }
            imageLeftOrRight
            image {
              file {
                url
              }
              gatsbyImageData(
                jpegProgressive: true
                layout: FULL_WIDTH
                resizingBehavior: SCALE
              )
            }
            blockTitle
            imageLink
            text {
              raw
            }
          }
          ... on ContentfulContentBlockJumpLinkComponent {
            contentful_id
            internal {
              type
            }
            identifier
          }
          ... on ContentfulEdc22ContentBlockButton {
            buttonColor
            buttonText
            buttonTitle
            buttonUrl
            internal {
              type
            }
            contentful_id
            node_locale
            internalPageReference {
              ... on ContentfulPageAccountDetail {
                id
                slug
              }
            }
          }
        }
      }
    }
  `)

  const inlineEntry = inlines.nodes.find(
    node =>
      node.contentful_id === inlineID &&
      node.node_locale === process.env.language,
  )
  if (inlineEntry === undefined) {
    return "/404"
  } else if (
    inlineEntry.internal?.type === "ContentfulContentBlockHubSpotForm"
  ) {
    return inlineEntry
  } else if (
    inlineEntry.internal?.type === "ContentfulContentBlockJumpLinkComponent"
  ) {
    return inlineEntry
  } else if (
    inlineEntry.internal?.type === "ContentfulEdc22ContentBlockImageAndTextLink"
  ) {
    return inlineEntry
  } else if (
    inlineEntry.internal?.type === "ContentfulEdc22ContentBlockSlider"
  ) {
    return inlineEntry
  } else {
    return [
      inlineEntry.buttonUrl,
      inlineEntry.buttonText,
      inlineEntry.buttonColor,
      inlineEntry.internalPageReference?.slug,
    ]
  }
}
